export const PAGE_LOADING = 'PAGE_LOADING'
export const MENU_LOADING = 'MENU_LOADING'
export const UPDATE_CONTENT_LOADING = 'UPDATE_CONTENT_LOADING'
export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE'
export const UPDATE_MENUSARR = 'UPDATE_MENUSARR'
export const UPDATE_CURRENT_MENUS = 'UPDATE_CURRENT_MENUS'
export const UPDATE_INIT_DATA = 'UPDATE_INIT_DATA'
export const UPDATE_SHOW_MENUS = 'UPDATE_SHOW_MENUS'
export const UPDATE_USER = 'UPDATE_USER'
export const UPDATE_EDIT_USER = 'UPDATE_EDIT_USER'
export const UPDATE_PUBLISHER_ID = 'UPDATE_PUBLISHER_ID'
export const UPDATE_PUBLISHER_INFO = 'UPDATE_PUBLISHER_INFO'
export const UPDATE_JOURNAL_LIST = 'UPDATE_JOURNAL_LIST'
export const UPDATE_DOMAIN = 'UPDATE_DOMAIN'
export const UPDATE_COUNTRY = 'UPDATE_COUNTRY'
export const UPDATE_GENDER = 'UPDATE_GENDER'
export const UPDATE_TITLE = 'UPDATE_TITLE'
export const UPDATE_EDITORIAL_BOARD = 'UPDATE_EDITORIAL_BOARD'
export const UPDATE_GUEST_EDITOR = 'UPDATE_GUEST_EDITOR'
export const UPDATE_MANAGEMENT_TEAM = 'UPDATE_MANAGEMENT_TEAM'
export const UPDATE_JOURNAL_ID = 'UPDATE_JOURNAL_ID'
export const UPDATE_PERSONAL_JOURNAL_LIST = 'UPDATE_PERSONAL_JOURNAL_LIST'

export const UPDATE_ATTACHMENT_TYPE = 'UPDATE_ATTACHMENT_TYPE'
export const UPDATE_DEGREE = 'UPDATE_DEGREE'
export const UPDATE_HIGHEST_DEGREE = 'UPDATE_HIGHEST_DEGREE'
export const UPDATE_MANUSCRIPT_TYPE = 'UPDATE_MANUSCRIPT_TYPE'
export const UPDATE_MANUSCRIPT_TYPE_LIST = 'UPDATE_MANUSCRIPT_TYPE_LIST'
export const UPDATE_REVIEW_FREQUENCY = 'UPDATE_REVIEW_FREQUENCY'
export const UPDATE_REVIEW_TYPE = 'UPDATE_REVIEW_TYPE'
export const UPDATE_MANUSCRIPT = 'UPDATE_MANUSCRIPT'
export const UPDATE_REVIEW_REFUSE = 'UPDATE_REVIEW_REFUSE'
export const UPDATE_INDEXED_DATABASE = 'UPDATE_INDEXED_DATABASE'
export const UPDATE_SECTION_EDITOR = 'UPDATE_SECTION_EDITOR'
export const UPDATE_ACADEMIC_RANK = 'UPDATE_ACADEMIC_RANK'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
